import { render, staticRenderFns } from "./CardIncentive.vue?vue&type=template&id=24b91be5&"
import script from "./CardIncentive.vue?vue&type=script&lang=js&"
export * from "./CardIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports